module.exports = __webpack_public_path__ + "assets/img/gif-3.acb17b1d.gif";